import { api } from '../api';  // CORRIGIDO: Importação do diretório pai
import { authService } from '../authService';
import { logError } from '../../utils/logger';

// Interfaces
export interface PadraoConsulta {
  pacienteId: string;
  nomePaciente: string;
  diaDaSemana: number;
  hora: string;
  frequencia: number;
  valor: number;
}

export interface ConsultaRecorrenteInput {
  pacienteId: string;
  horaInicio: string; // CORRIGIDO: Usar horaInicio para compatibilidade com o backend
  horaFim?: string;
  valor: number;
  usuarioId: string;
  observacoesAgendamento?: string;
}

export interface OpcoesConsultaRecorrente {
  diaDaSemana: number;
  dataInicio: string;
  quantidadeSemanas: number;
  consultaMensal?: boolean;
}

export interface ResultadoConsultaRecorrente {
  sucesso: boolean;
  mensagem: string;
  consultasCriadas: any[];
}

// Serviço de consultas recorrentes
export const consultasRecorrentesService = {
  /**
   * Obtém padrões de consultas recorrentes
   */
  async obterPadroesConsultas(): Promise<PadraoConsulta[]> {
    try {
      const response = await api.get<PadraoConsulta[]>('/consultas-recorrentes/padroes-recorrentes');
      return response.data;
    } catch (error) {
      logError('ConsultasRecorrentesService', 'Erro ao obter padrões de consultas', error);
      return [];
    }
  },
  
  /**
   * Agenda consultas recorrentes
   */
  async agendarConsultasRecorrentes(
    consulta: ConsultaRecorrenteInput, 
    opcoes: OpcoesConsultaRecorrente
  ): Promise<ResultadoConsultaRecorrente> {
    try {
      // CORREÇÃO: Validar dados antes de enviar
      if (!consulta.pacienteId || !consulta.horaInicio || !consulta.usuarioId || isNaN(consulta.valor)) {
        console.error('[ConsultasRecorrentesService] Dados inválidos:', { consulta });
        return {
          sucesso: false,
          mensagem: 'Dados incompletos para agendamento. Verifique se todos os campos obrigatórios foram preenchidos.',
          consultasCriadas: []
        };
      }
      
      // CORREÇÃO: Garantir que o token está incluso na requisição
      const token = authService.getToken();
      if (!token) {
        console.error('[ConsultasRecorrentesService] Token não encontrado');
        return {
          sucesso: false,
          mensagem: 'Erro de autenticação. Por favor, faça login novamente.',
          consultasCriadas: []
        };
      }
      
      console.log('[ConsultasRecorrentesService] Enviando requisição:', {
        consulta: {
          ...consulta,
          pacienteId: consulta.pacienteId,
          usuarioId: consulta.usuarioId,
          valor: consulta.valor
        },
        opcoes
      });
      
      const response = await api.post<any>(
        '/consultas-recorrentes/agendar-recorrentes',
        { consulta, opcoes },
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      
      console.log('[ConsultasRecorrentesService] Resposta recebida:', response.data);
      
      // CORREÇÃO: Normalizar sempre a resposta para ter o campo sucesso
      const responseData = response.data;
      
      // Se a API não retornar o campo sucesso, determiná-lo pelo conteúdo
      const resultado: ResultadoConsultaRecorrente = {
        sucesso: responseData.sucesso ?? (
          !!(responseData.consultasCriadas && 
             Array.isArray(responseData.consultasCriadas) && 
             responseData.consultasCriadas.length > 0 &&
             responseData.mensagem?.toLowerCase().includes('sucesso'))
        ),
        mensagem: responseData.mensagem || 'Operação realizada',
        consultasCriadas: responseData.consultasCriadas || []
      };
      
      console.log('[ConsultasRecorrentesService] Resultado normalizado:', resultado);
      return resultado;
    } catch (error) {
      logError('ConsultasRecorrentesService', 'Erro ao agendar consultas recorrentes', error);
      
      let mensagem = 'Erro ao agendar consultas recorrentes';
      
      if (error && typeof error === 'object' && 'response' in error) {
        const apiError = error as any;
        if (apiError.response?.data?.mensagem) {
          mensagem = apiError.response.data.mensagem;
        }
      }
      
      return {
        sucesso: false,
        mensagem,
        consultasCriadas: []
      };
    }
  }
};

export default consultasRecorrentesService;
